import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { IsAccountValidGuard } from './base/is-account-valid.guard';
import { LoadDomainIfExistsGuard } from './base/load-domain-if-exists.guard';
import { LoadServicesGuard } from './base/load-services.guard';
import { isPlatformServer } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class DropboxUploaderGuard {

  constructor(
    private loadDomainGuardIfExists: LoadDomainIfExistsGuard,
    private loadServicesGuard: LoadServicesGuard,
    private isAccountValidGuard: IsAccountValidGuard,
    @Inject(PLATFORM_ID) private platformId: object,
  ) { }

  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (isPlatformServer(this.platformId)) {
      return of(true)
    }
    return this.loadDomainGuardIfExists.canActivate().pipe(mergeMap((domainLoaded: boolean) => {
      if (domainLoaded) {
        return this.loadServicesGuard.canActivate().pipe(mergeMap((servicesLoaded: boolean) => {
          if (servicesLoaded) {
            return this.isAccountValidGuard.canActivate().pipe(mergeMap((isAccountValid: boolean) => {
              if (isAccountValid) {
                return of(isAccountValid);
              }
            }));

          }
        }));
      }
    }));
  }
}
